import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const GenderRadioGroup = ({ value, onChange}) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        value={value}
        onChange={onChange}
        name="gender"
      >
        <FormControlLabel value="male" control={<Radio />} label="Male" />
        <FormControlLabel value="female" control={<Radio />} label="Female" />
      </RadioGroup>
    </FormControl>
  );
};

export default GenderRadioGroup;